<div class="password-fields" [formGroup]="passwordFormGroup">
  <cap-password [toggleMask]="true" formControlName="password" />

  <label>
    {{ props.confirmPasswordLabelKey | translate }}
  </label>

  <cap-password [toggleMask]="true" formControlName="confirm_password" />
</div>

<div class="generate-password">
  <cap-button
    [styleClass]="'secondary ' + props.buttonStyleClass || ''"
    icon="mynaui-key"
    [label]="'user.detail.generate-password.label' | translate"
    (onClick)="generatePassword()" />
</div>
